// Credit:

import { Arrays } from "ixfx/data";

// https://2colors.colorion.co/
const bidi = [
  ` #50586C #DCE2F0`,
  ` #815854 #F9EBDE`,
  ` #1E4174 #DDA94B`,
  ` #A4193D #FFDFB9`,
  ` #1AAFBC #80634C`,
  ` #FFDFDE #6A7BA2`,
  ` #3B1877 #DA5A2A`,
  ` #5F4B8B #E69A8D`,
  ` #000000 #FFFFFF`,
  ` #00203F #ADEFD1`,
  ` #606060 #D6ED17`,
  ` #2C5F2D #97BC62`,
  ` #00539C #EEA47F`,
  ` #0063B2 #9CC3D5`,
  ` #101820 #FEE715`,
  ` #CBCE91 #d3687f`,
  ` #B1624E #5CC8D7`,
  ` #7b9acc #FCF6F5`,
  ` #101820 #F2AA4C`,
  ` #A07855 #D4B996`,
  ` #195190 #A2A2A1`,
  ` #603F83 #C7D3D4`,
  ` #FAD0C9 #6E6E6D`,
  ` #2D2926 #ed6f63`,
  ` #DAA03D #616247`,
  ` #990011 #FCF6F5`,
  ` #364b44 #D64161`,
  ` #CBCE91 #76528B`,
  ` #FAEBEF #333D79`,
  ` #c72d1b #FDD20E`,
  ` #F2EDD7 #755139`,
  ` #1a7a4c #101820`,
  ` #F95700 #FFFFFF`,
  ` #FFD662 #00539C`,
  ` #D7C49E #D7C49E`,
  ` #cf8360 #F5C7B8`,
  ` #DF6589 #3C1053`,
  ` #FFE77A #2C5F2D`,
  ` #e9877e #9E1030`,
  ` #FCF951 #422057`,
  ` #4B878B #921416`,
  ` #1C1C1B #CE4A7E`,
  ` #00B1D2 #FDDB27`,
  ` #558600 #ff9967`,
  ` #BD7F37 #A13941`,
  ` #eedfe2 #9FC131`,
  ` #00239C #ed6a66`,
  ` #F96167 #FCE77D`,
  ` #F9D142 #292826`,
  ` #DF678C #3D155F`,
  ` #CCF381 #4831D4`,
  ` #4A274F #F0A07B`,
  ` #02343F #F0EDCC`,
  ` #331B3F #ACC7B4`,
  ` #0A174E #F5D042`,
  ` #07553B #CED46A`,
  ` #50586C #DCE2F0`,
  ` #815854 #F9EBDE`,
  ` #1E4174 #DDA94B`,
  ` #A4193D #FFDFB9`,
  ` #1AAFBC #80634C`,
  ` #FFDFDE #6A7BA2`,
  ` #3B1877 #DA5A2A`,
  ` #5F4B8B #E69A8D`,
  ` #00203F #ADEFD1`,
  ` #606060 #D6ED17`,
  ` #2C5F2D #97BC62`,
  ` #00539C #EEA47F`,
  ` #0063B2 #9CC3D5`,
  ` #101820 #FEE715`,
  ` #CBCE91 #d3687f`,
  ` #B1624E #5CC8D7`,
  ` #7b9acc #FCF6F5`,
  ` #101820 #F2AA4C`,
  ` #A07855 #D4B996`,
  ` #195190 #A2A2A1`,
  ` #603F83 #C7D3D4`,
  ` #2BAE66 #FCF6F5`,
  ` #FAD0C9 #6E6E6D`,
  ` #2D2926 #ed6f63`,
  ` #DAA03D #616247`
]

export const getBidi = () => {
  const selected = Arrays.randomElement(bidi);
  const split = selected.trim().split(` `);
  return split.map(v => v.trim());
}